export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const FORM_NAME = 'create-req-modal';

export const REQUIRED_FIELDS = [
	'category_id',
	'tender_type_id',
	'fetch_at',
	'fetch_time_from',
	'fetch_time_to',
	'type_id',
	'mode_id',
];

export const FORM_FIELDS = [
	'category_id',
	'tender_type_id',
	'tender_tk_id',
	'tender_amount',
	'fetch_at',
	'fetch_time_from',
	'fetch_time_to',
	'type_id',
	'mode_id',
];

export const MY_CARRIER_REQUIRED_FIELDS = ['tender_type_id', 'tender_tk_id', 'tender_amount'];
